import { useState, useEffect } from 'react'
import queryString from 'query-string'
import moment from 'moment'
import { useHistory, useLocation } from 'react-router-dom'

//recreating this for a single item. useVariableFilter would be used like const { variable: foo, setVariable:setFoo } = useVariableFilter(foo, 'mydefaultValue')

const useUrlState = (name, defaultValue = null) => {

    const history = useHistory()
    const location = useLocation()
    const queryParams = queryString.parse(location.search)
    let init
    if (queryParams[name]) {
        init = queryParams[name]
    } else {
        init = defaultValue
    }
    const [variable, setVariable] = useState(init)

    // Initialize the variable from query params or default value from URL on mount
    useEffect(() => {
        const queryParams = queryString.parse(location.search)
        if (queryParams[name]) {
            setVariable(queryParams[name])
        } else {
            setVariable(defaultValue)
        }
    }, [])

    // Update the URL query params whenever the variable changes
    useEffect(() => {
       // Get the CURRENT search params from window.location.search, not from the stale location object
    const queryParams = queryString.parse(window.location.search)
    const currentValue = queryParams[name];


    // Only update if the value has actually changed
    if ((variable === null || variable === undefined) && currentValue !== undefined) {
        delete queryParams[name]
        window.history.replaceState(
            null,
            '',
            `${location.pathname}?${queryString.stringify(queryParams)}`
        )
        
    } else if (variable !== null && variable !== undefined && currentValue !== variable.toString()) {
        queryParams[name] = variable
        window.history.replaceState(
            null,
            '',
            `${location.pathname}?${queryString.stringify(queryParams)}`
        )
    }
  
    }, [variable, name, location.pathname, history])



    return [variable, setVariable]
}

export default useUrlState